// Marathi
const dict = {
  // Brand / common
  "Every Win, Securely Paid.": "प्रत्येक विजय, सुरक्षित पेमेंट.",
  "Loading Sara777": "Sara777 लोड होत आहे",
  "App version {version}": "ॲप आवृत्ती {version}",
  "Language": "भाषा",
  "Home": "होम",
  "Account": "खाते",
  "Wallet": "वॉलेट",
  "History": "इतिहास",
  "All Bids": "सर्व बोली",
  "Profile": "प्रोफाइल",
  "My Profile": "माझे प्रोफाइल",
  "Open menu": "मेनू उघडा",
  "Close menu": "मेनू बंद करा",
  "Go back": "मागे जा",
  "Back": "मागे",
  "Close": "बंद",
  "Open": "ओपन",
  "Submit": "सबमिट करा",
  "Cancel": "रद्द करा",
  "Continue": "पुढे चला",
  "Update": "अपडेट करा",
  "Copy": "कॉपी करा",
  "Change": "बदला",
  "Refresh": "रिफ्रेश करा",
  "Date": "तारीख",
  "Status": "स्थिती",
  "Action": "क्रिया",
  "Remark": "शेरा",
  "Amount": "रक्कम",
  "Points": "पॉइंट्स",
  "Bids": "बोली",
  "Session": "सत्र",
  "Pending": "प्रलंबित",
  "Failed": "अयशस्वी",
  "Success": "यशस्वी",
  "optional": "ऐच्छिक",
  "Since {date}": "{date} पासून",

  // Sidebar
  "Account Statement": "खाते विवरण",
  "Game Rates": "गेम दर",
  "Terms & Conditions": "नियम व अटी",
  "Video": "व्हिडिओ",
  "Logout": "लॉग आउट",
  "Privacy Policy": "गोपनीयता धोरण",

  // Login / sign-up / MPIN / OTP
  "Login": "लॉगिन",
  "Sign up": "साइन अप करा",
  "New here?": "नवीन आहात?",
  "Already have an account?": "आधीच खाते आहे?",
  "Have an account?": "खाते आहे?",
  "Enter Number": "नंबर टाका",
  "Enter your valid mobile number": "तुमचा योग्य मोबाइल नंबर टाका",
  "Mobile number": "मोबाइल नंबर",
  "Mobile Number": "मोबाइल नंबर",
  "Enter mobile number": "मोबाइल नंबर टाका",
  "4-digit MPIN": "4 अंकी MPIN",
  "Enter your 4-digit MPIN": "तुमचा 4 अंकी MPIN टाका",
  "Show MPIN": "MPIN दाखवा",
  "Hide MPIN": "MPIN लपवा",
  "Create Account": "खाते तयार करा",
  "Create your new account": "तुमचे नवीन खाते तयार करा",
  "Full name": "पूर्ण नाव",
  "Email address (optional)": "ईमेल पत्ता (ऐच्छिक)",
  "Create MPIN": "MPIN तयार करा",
  "Set a 4-digit PIN to log in quickly": "पटकन लॉगिनसाठी 4 अंकी PIN सेट करा",
  "Enter MPIN": "MPIN टाका",
  "Confirm MPIN": "MPIN ची खात्री करा",
  "{label} digit {n}": "{label} अंक {n}",
  "Never share your MPIN with anyone.": "तुमचा MPIN कधीही कोणालाही सांगू नका.",
  "MPINs match": "MPIN जुळतात",
  "MPINs don't match. Try again.": "MPIN जुळत नाहीत. पुन्हा प्रयत्न करा.",
  "Enter your MPIN to login": "लॉगिनसाठी तुमचा MPIN टाका",
  "Enter OTP": "OTP टाका",
  "Verify your mobile number": "तुमचा मोबाइल नंबर सत्यापित करा",
  "Verify": "सत्यापित करा",

  // Home
  "Add Money": "पैसे जोडा",
  "Withdraw": "पैसे काढा",
  "Betting is Running Now": "बेटिंग आता सुरू आहे",
  "Betting is Closed for Today": "आजसाठी बेटिंग बंद आहे",
  "Play {name}": "{name} खेळा",
  "{name} chart": "{name} चार्ट",
  "Chart Info": "चार्ट माहिती",
  "Contact Support": "सपोर्टशी संपर्क करा",
  "Jodi Chart": "जोडी चार्ट",
  "Pana Chart": "पाना चार्ट",
  "Past jodi results": "मागील जोडी निकाल",
  "Past panna results": "मागील पाना निकाल",
  "Call Now": "आता कॉल करा",
  "Talk to our support team": "आमच्या सपोर्ट टीमशी बोला",
  "WhatsApp": "व्हॉट्सॲप",
  "Chat with us on WhatsApp": "व्हॉट्सॲपवर आमच्याशी चॅट करा",

  // Game types
  "Select a game type to play": "खेळण्यासाठी गेम प्रकार निवडा",
  "Single Digit": "सिंगल अंक",
  "Single Digit Bulk": "सिंगल अंक बल्क",
  "Jodi Digit": "जोडी अंक",
  "Jodi Digit Bulk": "जोडी अंक बल्क",
  "Single Pana": "सिंगल पाना",
  "Single Pana Bulk": "सिंगल पाना बल्क",
  "Double Pana": "डबल पाना",
  "Double Pana Bulk": "डबल पाना बल्क",
  "Triple Pana": "ट्रिपल पाना",
  "Triple Pana Bulk": "ट्रिपल पाना बल्क",
  "Half Sangam": "हाफ संगम",
  "Full Sangam": "फुल संगम",
  "Jodi": "जोडी",
  "Single Panna": "सिंगल पाना",
  "Double Panna": "डबल पाना",
  "Triple Panna": "ट्रिपल पाना",
  "Tripple Panna": "ट्रिपल पाना",

  // Playing
  "Enter points": "पॉइंट्स टाका",
  "Enter {label}": "{label} टाका",
  "Add Bid": "बोली जोडा",
  "Submit Bid": "बोली सबमिट करा",
  "Pana": "पाना",
  "Digits": "अंक",
  "Open Pana": "ओपन पाना",
  "Close Pana": "क्लोज पाना",
  "Open Digit": "ओपन अंक",
  "Close Digit": "क्लोज अंक",
  "No bids added yet": "अजून एकही बोली जोडलेली नाही",
  "Remove bid {number}": "बोली {number} काढा",
  "Bid status": "बोलीची स्थिती",
  "Note: Bid once played will not be cancelled": "टीप: एकदा लावलेली बोली रद्द होणार नाही",
  "HOLD": "होल्ड",
  "LOADING...": "लोड होत आहे...",
  "Failed !!": "अयशस्वी !!",

  // Bids / history
  "Transaction ID": "व्यवहार ID",
  "Placed": "लावली",
  "No bid history found.": "बोलीचा इतिहास सापडला नाही.",
  "Balance": "शिल्लक",
  "No transactions yet": "अजून कोणतेही व्यवहार नाहीत",
  "Deposit": "जमा",
  "No history found.": "इतिहास सापडला नाही.",
  "In Process": "प्रक्रियेत",
  "Declined": "नाकारले",
  "User Withdrawal / deposit History": "पैसे काढणे / जमा इतिहास",

  // Charts
  "Bottom": "खाली",
  "Back to top": "वर जा",
  "Mon": "सोम",
  "Tue": "मंगळ",
  "Wed": "बुध",
  "Thu": "गुरु",
  "Fri": "शुक्र",
  "Sat": "शनि",
  "Sun": "रवि",

  // Rates / how to play
  "Main game win ratio for all bids": "सर्व बोलींसाठी मुख्य गेम विजय प्रमाण",
  "{min} KA {max}": "{min} चे {max}",
  "How To Play": "कसे खेळावे",
  "Download our application from Google Play Store or from our official website.": "आमचे ॲप Google Play Store किंवा आमच्या अधिकृत वेबसाइटवरून डाउनलोड करा.",
  "Register with your Mobile Number, Email ID, and User Name on our platform.": "आमच्या प्लॅटफॉर्मवर तुमचा मोबाइल नंबर, ईमेल ID आणि युजर नेम वापरून नोंदणी करा.",
  "Login to the application using your Mobile Number and MPIN.": "तुमचा मोबाइल नंबर आणि MPIN वापरून ॲपमध्ये लॉगिन करा.",
  "Select the Game type, choose your favourite number, and start to play the game.": "गेम प्रकार निवडा, तुमचा आवडता नंबर निवडा आणि खेळायला सुरुवात करा.",
  "Get a chance to win up to 10 Lac Points.": "10 लाख पॉइंट्सपर्यंत जिंकण्याची संधी मिळवा.",

  // Wallet
  "Add Fund": "फंड जोडा",
  "Instant deposit via UPI / QR Code": "UPI / QR कोडद्वारे त्वरित जमा",
  "Manual Deposit": "मॅन्युअल जमा",
  "Upload your payment screenshot": "तुमच्या पेमेंटचा स्क्रीनशॉट अपलोड करा",
  "Withdraw Fund": "फंड काढा",
  "Fast and secure withdrawal to bank": "बँकेत जलद आणि सुरक्षित पैसे काढणे",
  "Deposit & Withdraw History": "जमा आणि पैसे काढण्याचा इतिहास",
  "Check your past transactions statement": "तुमच्या मागील व्यवहारांचे विवरण पहा",
  "Add Bank Details": "बँक तपशील जोडा",
  "Update bank account for instant payouts": "त्वरित पेमेंटसाठी बँक खाते अपडेट करा",
  "Total Wallet Balance": "एकूण वॉलेट शिल्लक",
  "Pay": "पेमेंट करा",
  "Minimum deposit limit is {amount}.": "किमान जमा मर्यादा {amount} आहे.",
  "Enter withdraw points": "काढायचे पॉइंट्स टाका",
  "Amount is sent to your saved bank account.": "रक्कम तुमच्या सेव्ह केलेल्या बँक खात्यात पाठवली जाते.",
  "Update bank details": "बँक तपशील अपडेट करा",
  "Pay to the UPI ID below, then enter the UTR number and upload the payment screenshot.": "खालील UPI ID वर पेमेंट करा, नंतर UTR नंबर टाका आणि पेमेंटचा स्क्रीनशॉट अपलोड करा.",
  "Enter amount": "रक्कम टाका",
  "Pay to UPI ID": "या UPI ID वर पेमेंट करा",
  "UTR Number": "UTR नंबर",
  "Enter 12-digit UTR number": "12 अंकी UTR नंबर टाका",
  "Payment Screenshot": "पेमेंट स्क्रीनशॉट",
  "Tap to upload screenshot": "स्क्रीनशॉट अपलोड करण्यासाठी टॅप करा",
  "Tap to change": "बदलण्यासाठी टॅप करा",
  "PNG or JPG": "PNG किंवा JPG",
  "Bank Details": "बँक तपशील",
  "IFSC Code": "IFSC कोड",
  "Account number": "खाते क्रमांक",
  "Bank name": "बँकेचे नाव",
  "Account holder name": "खातेधारकाचे नाव",
  "Google Pay number": "Google Pay नंबर",
  "PhonePe number": "PhonePe नंबर",
  "Paytm number": "Paytm नंबर",

  // Profile
  "Edit profile": "प्रोफाइल बदला",
  "Joined since": "सामील झाल्यापासून",
  "Phone": "फोन",
  "Wallet Balance": "वॉलेट शिल्लक",
  "Update User Information": "युजर माहिती अपडेट करा",
  "Name": "नाव",
  "Email": "ईमेल",
  "PhonePe": "PhonePe",
  "Google Pay": "Google Pay",
  "Paytm": "Paytm",
  "Name is required.": "नाव आवश्यक आहे.",
  "Email is required.": "ईमेल आवश्यक आहे.",
  "Email is invalid.": "ईमेल चुकीचा आहे.",
  "PhonePe number must be 10 digits.": "PhonePe नंबर 10 अंकी असावा.",
  "Paytm number must be 10 digits.": "Paytm नंबर 10 अंकी असावा.",
  "Google Pay number must be 10 digits.": "Google Pay नंबर 10 अंकी असावा.",

  // Pop-up messages
  "Enter User name !!": "युजर नेम टाका !!",
  "Enter Valid mobile number !!": "योग्य मोबाइल नंबर टाका !!",
  "Enter Valid email address !!": "योग्य ईमेल पत्ता टाका !!",
  "Enter your 4-digit MPIN !!": "तुमचा 4 अंकी MPIN टाका !!",
  "Only 4 digit allow !!": "फक्त 4 अंक चालतील !!",
  "Mpin does not match with confirm Mpin.": "MPIN आणि खात्री MPIN जुळत नाहीत.",
  "This number is already registered. Please login.": "हा नंबर आधीच नोंदणीकृत आहे. कृपया लॉगिन करा.",
  "This number is not registered. Please create your account.": "हा नंबर नोंदणीकृत नाही. कृपया तुमचे खाते तयार करा.",
  "Unable to sign in. Please try again.": "लॉगिन होऊ शकले नाही. कृपया पुन्हा प्रयत्न करा.",
  "Unable to continue. Please try again.": "पुढे जाता आले नाही. कृपया पुन्हा प्रयत्न करा.",
  "Unable to create account. Please try again.": "खाते तयार होऊ शकले नाही. कृपया पुन्हा प्रयत्न करा.",
  "Api Error": "सर्व्हर त्रुटी",
  "Something went wrong. Please try again.": "काहीतरी चूक झाली. कृपया पुन्हा प्रयत्न करा.",
  "This Market Betting Is Closed For Today.": "या मार्केटमध्ये आजसाठी बेटिंग बंद आहे.",
  "Please Enter minimum 10 Points.": "कृपया किमान 10 पॉइंट्स टाका.",
  "Please Enter Points for Betting.": "कृपया बेटिंगसाठी पॉइंट्स टाका.",
  "Please Select Bids for Betting.": "कृपया बेटिंगसाठी बोली निवडा.",
  "Please enter a valid Number.": "कृपया योग्य नंबर टाका.",
  "Please Enter Amount first.": "कृपया आधी रक्कम टाका.",
  "Please Enter UTR first.": "कृपया आधी UTR टाका.",
  "Please select a valid image file.": "कृपया योग्य इमेज फाइल निवडा.",
  "UPI copied to clipboard!": "UPI क्लिपबोर्डवर कॉपी झाला!",
  "Profile Updated Successfully.": "प्रोफाइल यशस्वीरित्या अपडेट झाले.",
};

export default dict;
